import { apiClient } from '../config';
import { endpoints } from '../endpoints';

export const notificationService = {
  getNotifications: async (params = {}) => {
    const response = await apiClient.get(endpoints.notifications.list, { params });
    return response.data;
  },

  setReadState: async (id, read) => {
    const response = await apiClient.patch(endpoints.notifications.update(id), { read });
    return response.data;
  },

  markAllRead: async () => {
    const response = await apiClient.post(endpoints.notifications.readAll);
    return response.data;
  },

  getNotificationPreferences: async () => {
    const response = await apiClient.get(endpoints.notifications.preferences.get);
    return response.data;
  },

  updateNotificationPreferences: async (preferences) => {
    const response = await apiClient.put(endpoints.notifications.preferences.update, preferences);
    return response.data;
  },

  getRecentActivity: async (limit = 10) => {
    const response = await apiClient.get(endpoints.activity.mine, { params: { limit } });
    return response.data.items || [];
  }
};
